import moment from 'moment';

import {
  shipmentGridViewIdConstants,
  DELIVERY_EXCEPTION_VIEW_ID,
  DELIVERED_VIEW_ID,
  IN_TRANSIT_VIEW_ID,
  RECENT_VIEW_ID,
  SCHEDULED_PICKUPS_VIEW_ID,
  FULFILLMENTS_RECENT_VIEW_ID,
  FULFILLMENTS_PENDING_VIEW_ID,
  FULFILLMENTS_IN_TRANSIT_VIEW_ID,
  FULFILLMENTS_DELIVERED_VIEW_ID,
  FULFILLMENTS_DELIVERY_EXCEPTION_VIEW_ID,
  FULFILLMENTS_CANCELLED_VIEW_ID,
  FULFILLMENTS_ADVANCED_SEARCH_VIEW_ID,
} from '../components/shipping-grid/views/view-id-constants';
import { DateService } from '../services/date-service';

const makeMoment = (value, unit) => {
  return moment().subtract(value, unit).format(DateService.dateFormat);
};

const shipDateFilterMap = {
  [DELIVERED_VIEW_ID]: makeMoment(30, 'days'),
  [DELIVERY_EXCEPTION_VIEW_ID]: makeMoment(30, 'days'),
  [IN_TRANSIT_VIEW_ID]: makeMoment(30, 'days'),
  [RECENT_VIEW_ID]: makeMoment(14, 'days'),
};

class ShipmentsGridViewServiceClass {
  isValidViewId(viewId) {
    return Object.values(shipmentGridViewIdConstants).filter((id) => id === viewId).length > 0;
  }

  getRouteFilter() {
    return `(${Object.values(shipmentGridViewIdConstants)
      .filter((id) => id !== SCHEDULED_PICKUPS_VIEW_ID)
      .join('|')})`;
  }

  getFulfillmentRouteFilter() {
    return [
      FULFILLMENTS_RECENT_VIEW_ID,
      FULFILLMENTS_PENDING_VIEW_ID,
      FULFILLMENTS_IN_TRANSIT_VIEW_ID,
      FULFILLMENTS_DELIVERED_VIEW_ID,
      FULFILLMENTS_DELIVERY_EXCEPTION_VIEW_ID,
      FULFILLMENTS_CANCELLED_VIEW_ID,
      FULFILLMENTS_ADVANCED_SEARCH_VIEW_ID,
    ].join('|');
  }

  isViewWithDefaultShipDateFilter(viewId) {
    return [DELIVERED_VIEW_ID, DELIVERY_EXCEPTION_VIEW_ID, IN_TRANSIT_VIEW_ID, RECENT_VIEW_ID].includes(viewId);
  }

  getShipDateFilterParamForView(viewId) {
    return { shipDateTimeGte: shipDateFilterMap[viewId] };
  }
}

export const ShipmentsGridViewService = new ShipmentsGridViewServiceClass();
